export default class ReturnType {
  htmlTagsToAttributes = new Map([
    ['div', 'textContent'],
    ['label', 'value'],
    ['input', 'value'],
    ['textarea', 'value'],
    ['span', 'textContent'],
    ['p', 'textContent'],
    ['h1', 'textContent'],
    ['h2', 'textContent'],
    ['h3', 'textContent'],
    ['h4', 'textContent'],
    ['h5', 'textContent'],
    ['h6', 'textContent'],
    ['li', 'textContent'],
    ['ul', 'textContent'],
    ['td', 'textContent'],
    ['img', 'src'],
    ['a', 'textContent'],
    ['option', 'textContent'],
    ['select', 'value']
  ]);

  functionality = '/** simple functionality*/';

  tryCatchTemplate = (command) => `try { ${command} } catch (e) { console.log(e) };`;

  constructor(annotations) {
    this.annotations = annotations;
  }

  printFunction() {
    return this.functionality;
  }

  returnAttributeType(attr) {
    return this.annotations[0].combinations
      .filter((annotation) => annotation.annotationName === attr)
      .map((annotation) => annotation.attributeType)[0];
  }

  returnAnnotationType(attr) {
    return this.annotations[0].combinations
      .filter((annotation) => annotation.annotationName === attr)
      .map((annotation) => annotation.annotationType)[0];
  }

  returnAttributeMap(annotationLink) {
    return this.annotations[0].combinations
      .filter((annotation) => annotation.annotationLink === annotationLink)
      .map((annotation) => annotation.annotationName);
  }

  newMapTemplate = () => `const map = new Map();`;

  addSelectOptions = (dataName, effectingArrayOfHtmlElements) => `
    if( ${dataName}.length > ${effectingArrayOfHtmlElements}.length){
      for(let i = 0; i <=  ${dataName}.length - ${effectingArrayOfHtmlElements}.length; i++){
        let parentNode = ${effectingArrayOfHtmlElements}[0].parentNode;
        let child = parentNode.childNodes[0].cloneNode(true);
        parentNode.appendChild(child);
        ${effectingArrayOfHtmlElements}.push(child);
      }
    }
  `;

  storeMapInLocalStorage = () =>
    `
    // Retrieve current data from local storage
    const storedData = window.localStorage.getItem("data");
    const currentData = storedData
        ? new Map(JSON.parse(storedData))
        : new Map();

    // Add new data to current data
    const newData = Array.from(map.entries());
    newData.forEach(([key, value]) => {
        currentData.set(key, value);
    });

    // Save updated data to local storage
    window.localStorage.setItem(
        "data",
        JSON.stringify(Array.from(currentData.entries()))
    );
    `;

  /**
   * Get the entity (entityLink) from an annotationName
   */
  getTheAnnotationLink(annotationName) {
    return this.annotation[0].combinations.filter(
      (annotation) => annotation.annotationName === annotationName
    )[0].annotationLink;
  }

  gatherSimpleQueries() {
    let simpleTuples = [...this.complexHtmlElementArray]
      .filter((element) => element.hasAttribute('annotationname'))
      .map(
        (element) => `${element.tagName.toLowerCase()}_${element.getAttribute('annotationname')}`
      );

    simpleTuples = [...new Set(simpleTuples)];
    const queryCommands = simpleTuples.map((tuple) => {
      const [tag, attrName] = tuple.split('_');

      return this.outputTemplate({
        dataName: this.dataNameOfLoop,
        effectingArrayOfHtmlElements: this.elementTemplate.elementArrayName,
        attr: attrName,
        htmlElement: this.htmlTagsToAttributes.get(tag),
        loopVariable: this.insideForLoopHtmlElementName,
        dataItemIndex:
          this.paginationList === true
            ? `i-(chunk-1) *${this.elementTemplate.elementArrayName}.length`
            : 'i'
      });
    });
    return queryCommands;
  }

  gatherComplexQueries() {
    const queriesTuples = this.getComplexHtmlElements(this.attributeArray).map((tuple) =>
      tuple.split('_')
    );

    const entitiesAsAttributes = this.annotations[0].combinations.filter(
      ({ annotationName, attributeType }) =>
        this.attributeArray.includes(annotationName) && attributeType === 'entity'
    );
    // TODO: Here I should distinguish the array
    const simpleQueriesTuples = queriesTuples.filter(
      (tuple) =>
        !entitiesAsAttributes.map(({ annotationName }) => annotationName).includes(tuple[1])
    );
    const entitiesQueriesTuples = queriesTuples.filter((tuple) =>
      entitiesAsAttributes.map(({ annotationName }) => annotationName).includes(tuple[1])
    );

    const simpleQueryCommands = simpleQueriesTuples.map(([tag, attrName]) => {
      const isTable =
        this.annotations[0].combinations.find(
          (annotation) => annotation.annotationName === attrName
        )?.annotationTable || false;

      if (this.singleType === true) {
        return this.outputTemplate(
          attrName,
          this.effectingHtmlElements[attrName],
          this.attachedAttributes[attrName]
        );
      }

      if (isTable)
        return this.outputTemplate({
          dataName: this.dataNameOfLoop,
          effectingArrayOfHtmlElements: this.elementTemplate.elementArrayName,
          attr: 'array',
          htmlElement: this.htmlTagsToAttributes.get(tag),
          loopVariable: this.insideForLoopHtmlElementName,
          itemAttr: attrName,
          dataItemIndex:
            this.paginationList === true
              ? `i-(chunk-1) *${this.elementTemplate.elementArrayName}.length`
              : 'i'
        });
      return this.outputTemplate({
        dataName: this.dataNameOfLoop,
        effectingArrayOfHtmlElements: this.elementTemplate.elementArrayName,
        attr: attrName,
        htmlElement: this.htmlTagsToAttributes.get(tag),
        loopVariable: this.insideForLoopHtmlElementName,
        dataItemIndex:
          this.paginationList === true
            ? `i-(chunk-1) *${this.elementTemplate.elementArrayName}.length`
            : 'i'
      });
    });

    const entitiesQueryCommands = this.generateEntitiesQueryCommands(
      entitiesQueriesTuples,
      entitiesAsAttributes
    );

    return [...simpleQueryCommands, ...entitiesQueryCommands];
  }

  generateEntitiesQueryCommands(entitiesQueriesTuples, entitiesAsAttributes) {
    // this check resolves if there are not any subentities annotation on the page
    if (!entitiesQueriesTuples.length) return [];

    const mapOfAnnotationNameToAttributes = entitiesAsAttributes.reduce(
      (acc, attribute) =>
        acc.set(attribute.annotationName, this.returnAttributeMap(attribute.customAttributeType)),
      new Map()
    );

    const tupleMap = [...mapOfAnnotationNameToAttributes.entries()].reduce(
      (acc, nameAttributeArray) => {
        acc.set(nameAttributeArray[0], this.getComplexHtmlElements(nameAttributeArray[1]));
        return acc;
      },
      new Map()
    );

    return this.generateSubDocAttributeQueries({
      tupleMap: [...tupleMap],
      nameOfSubdocumentElement: 'insideSubdocument',
      nameOfSubdocumentAttributeElement: 'attributeSubdocumentElement',
      entitiesAsAttributes
    });
  }

  // TODO: this should be refactored in order to facilitate the array implamentation
  generateSubDocAttributeQueries({
    tupleMap,
    nameOfSubdocumentAttributeElement,
    nameOfSubdocumentElement,
    entitiesAsAttributes
  }) {
    return tupleMap.map(([key, tagNameTuple]) => {
      const isArrayFlag = entitiesAsAttributes.reduce(
        (isArray, entity) => isArray || (entity.annotationName === key && entity.annotationTable),
        false
      );

      const queryCommandForAttributes = isArrayFlag
        ? this.getTableEntityQueries(
            key,
            tagNameTuple,
            'tableData',
            'tableDataElement',
            nameOfSubdocumentElement
          )
        : this.getEntityQueries(
            key,
            tagNameTuple,
            nameOfSubdocumentAttributeElement,
            nameOfSubdocumentElement
          );
      const attributeIndex =
        this.paginationList === true
          ? `i-(chunk-1) * ${this.elementTemplate.elementArrayName}.length`
          : 'i';

      const initEntityElement =
        this.singleType === true
          ? `const ${nameOfSubdocumentElement} = document.querySelector("[annotationname = '${key}']");`
          : `const ${nameOfSubdocumentElement} = ${this.elementTemplate.elementArrayName}[${attributeIndex}].querySelector("[annotationname = '${key}']");`;
      const singleTypeGetEntities =
        this.singleType === true
          ? this.outputTemplate(key, this.effectingHtmlElements[key], this.attachedAttributes[key])
          : '';

      const queriesCommandsForEntity = `
        ${singleTypeGetEntities}
        ${initEntityElement}
        if (${nameOfSubdocumentElement} !==null) {
          ${queryCommandForAttributes}
        }${this.fillMapSubEntity(key)}`;

      return queriesCommandsForEntity;
    });
  }

  getTableEntityQueries(
    key,
    tagNameTuple,
    tableDataName,
    tableDataElementName,
    nameOfSubdocumentElement
  ) {
    const inerLoopDataTableElementsName = 'data';
    const inerLoopDataTableName = 'tableData';
    const commandsForEachKey = tagNameTuple
      .map((tuple) => tuple.split('_'))
      .filter((tuple) => this.returnAnnotationType(tuple[1]) !== 'method')
      .map((tuple) => tuple)
      .reduce(
        (commands, [tag, name]) =>
          `${commands} ${this.getTableQuriesSubDocAttribute(
            inerLoopDataTableName,
            tableDataElementName,
            'index',
            name,
            tag
          )}`,
        ''
      );

    const initSubEntityTable =
      this.singleType === true
        ? `response.body.query`
        : `${this.dataNameOfLoop}[${this.dataNameOfLoop}.length - i - 1]`;

    const commandsToInsertArray = this.getCommandsToInsertArray({ key, tableDataName });

    const outerTemplate = `const ${tableDataName} = ${initSubEntityTable}.${key};
    ${commandsToInsertArray || ''}
    const ${tableDataElementName} = ${nameOfSubdocumentElement}.querySelectorAll("[dataitem='true']");
    ${tableDataName}.forEach((${inerLoopDataTableElementsName},index) => {
      if(${tableDataElementName}.length < index) {
        return;
      }
      ${commandsForEachKey}
      ${this.fillMapSubEntities(tableDataElementName, tableDataName)}
    });
    ${this.hideExtraNodes(tableDataElementName, tableDataName)}
    `;
    return outerTemplate;
  }

  getCommandsToInsertArray({ key, tableDataName }) {
    const subDocumentArray = [
      ...this.complexHtmlElement.querySelectorAll(`[annotationname=${key}]`)
    ];
    const arrayInputSubElements = subDocumentArray.reduce(
      (arrayAcc, subDocElement) =>
        arrayAcc.concat([...subDocElement.querySelectorAll('[arrayinput]')]),
      []
    );

    if (arrayInputSubElements.length > 1) return '/** Initialize failed */ \n';
    if (!arrayInputSubElements.length) return '';

    const inputArrayId = arrayInputSubElements[0].getAttribute('id');
    const panelToShowInputId = arrayInputSubElements[0]
      .querySelector('[panelToshowinput]')
      ?.getAttribute('id');
    let commandsToInsertArray = '';
    if (inputArrayId && panelToShowInputId)
      commandsToInsertArray = `initializearray${inputArrayId}(${tableDataName}); \n refreshUL${panelToShowInputId}();`;
    return commandsToInsertArray;
  }

  getEntityQueries(key, tagNameTuple, nameOfSubdocumentAttributeElement, nameOfSubdocumentElement) {
    const commandsForEachKey = tagNameTuple
      .map((tuple) => tuple.split('_'))
      .filter((tuple) => this.returnAnnotationType(tuple[1]) !== 'method')
      .map((tuple) => tuple)
      .reduce(
        (commands, [tag, name]) =>
          `${commands} ${this.getQueriesSubDocAttribute(
            nameOfSubdocumentAttributeElement,
            nameOfSubdocumentElement,
            name,
            tag,
            key
          )}`,
        ''
      );

    return commandsForEachKey;
  }

  getTableQuriesSubDocAttribute(tableDataName, tableDataElementName, forEachIndexName, name, tag) {
    return `try {
      const attributeSubdocumentElement = ${tableDataElementName}[
        ${forEachIndexName}
      ].querySelector("[annotationname = '${name}']");
      if (attributeSubdocumentElement !== null) {
        attributeSubdocumentElement.${this.htmlTagsToAttributes.get(
          tag
        )} = ${tableDataName}[${tableDataName}.length - index -1].${name};
      }
    }
    catch(e) {console.log(e);};`;
  }

  getQueriesSubDocAttribute(
    nameOfSubdocumentAttributeElement,
    nameOfSubdocumentElement,
    name,
    tag,
    key
  ) {
    const assignSubDocValue =
      this.singleType === true
        ? `response.body.query.`
        : `${this.dataNameOfLoop}[${this.dataNameOfLoop}.length - i - 1].`;

    return `try {const ${nameOfSubdocumentAttributeElement} = ${nameOfSubdocumentElement}.querySelector("[annotationname = '${name}']"); if (${nameOfSubdocumentAttributeElement} !== null) { ${nameOfSubdocumentAttributeElement}.${this.htmlTagsToAttributes.get(
      tag
    )} = ${assignSubDocValue}${key}.${name};}} catch (e) {console.log(e);};`;
  }

  fillMapSubEntity(key) {
    const index =
      this.paginationList === true
        ? `i-(chunk-1) * ${this.elementTemplate.elementArrayName}.length`
        : 'i';

    let queryElementResponse =
      this.singleType === true
        ? `response.body.query`
        : `${this.dataNameOfLoop}[${this.dataNameOfLoop}.length-i-1]`;
    let elementPlacement =
      this.singleType === true ? `document` : ` ${this.elementTemplate.elementArrayName}[${index}]`;

    return `
      if(${queryElementResponse}.${key}._id){
        map.set(
          ${elementPlacement}.querySelector(
            "[annotationname = '${key}']"
          ).getAttribute("id"),
          ${queryElementResponse}.${key}
        );
      }
    `;
  }

  fillMapSubEntities(tableDataElementName, tableDataName) {
    return `
      map.set(
        ${tableDataElementName}[index].getAttribute("id"),
        ${tableDataName}[${tableDataName}.length - index -1]
      );
    `;
  }

  hideExtraNodes(tableDataElementName, tableDataName) {
    return `
      [...${tableDataElementName}].forEach((element, index) => {
        if (index >= ${tableDataName}.length) {
          ${tableDataElementName}[index].style.display = "none";
        }
        else {
          ${tableDataElementName}[index].style.display = "";
        }
      });
    `;
  }

  /**
   * This function creates a tuple of html element tag and annotation in order
   * to be used with the querySelector template
   */
  getComplexHtmlElements(attributeArray) {
    if (!this.complexHtmlElementArray.length) return [];
    const querySelectorTuple = [...this.complexHtmlElementArray]
      .filter((element) => element.querySelectorAll('[annotationname]').length > 0)
      .reduce((acc, element) => [...acc, ...element.querySelectorAll('[annotationname]')], [])
      .filter((element) => attributeArray.includes(element.getAttribute('annotationname')))
      .reduce(
        (set, innerElement) =>
          set.add(
            `${innerElement.tagName.toLowerCase()}_${innerElement.getAttribute('annotationname')}`
          ),
        new Set()
      );
    return [...querySelectorTuple];
  }

  clearTemplate() {}
}
